import { LockIcon } from "@tandemdiabetes/sugarmate-react-components"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

// note: this is only for events, not subentries
export type Props = ComponentPropsWithoutRef<"svg">

export const ActivityLockIcon = forwardRef<SVGElement, Props>(
  function ActivityLockIcon(props: Props, ref: Ref<SVGElement>) {
    return (
      <LockIcon
        {...props}
        ref={ref}
      />
    )
  },
)
